import React from "react";

import { Button as DevexButton } from "devextreme-react/button";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import StickyBox from "react-sticky-box";

import "./group-title.scss";

export const GroupTitle = ({
  title,
  children,
}: {
  title: string;
  children: JSX.Element;
}) => {
  return (
    <div className="builder-group-title dx-fieldset">
      <div className="dx-field">
        <div className="dx-field-label dx-form-group-caption">{title}</div>
        <div className="dx-field-value-static">{children}</div>
      </div>
    </div>
  );
};

export const SideGroupTitle = ({
  title,
  sideKey,
}: {
  title: string;
  sideKey: string;
}) => {
  const { t } = useTranslation();
  return (
    <StickyBox style={{ zIndex: 1, background: "transparent" }}>
      <GroupTitle title={t(title)}>
        <DevexButton
          icon="clear"
          text={t("CLOSE")}
          stylingMode="text"
          type="danger"
          onClick={(e) => {
            e.event && e.event.stopPropagation();
            // dispatch(
            //   patchUiKey({
            //     detailStack: theDetailStack.filter((x) => x !== sideKey),
            //   })
            // );
          }}
          disabled={true}
        />
      </GroupTitle>
    </StickyBox>
  );
};
